import storage from "./storage";
import client from "./client";
import {debounce} from "lodash";

const MAX_MESSAGE_DELAY = 20000 // 20s - inactive time between message before sending

class Metric {
    constructor(storage,client) {
        this.storage = storage
        this.client = client

        // Debouncing sendMessage to avoid sending messages too frequently
        this.sendMessages = debounce(this._sendMessages.bind(this), MAX_MESSAGE_DELAY)
    }

    init() {
        // We can try to avoid having the browser closed before sending the messages
        // if we detect the cursor trying to exit the page we can send the messages immediately
        this.detectExitIntention(this._sendMessages.bind(this))
        // If we have old messages ( maybe the browser was closed before sending the messages )
        // We will send them first
        this._sendMessages()
    }


    detectExitIntention(action) {
        document.addEventListener('mouseout', (e) => {
            if (!e.toElement && !e.relatedTarget) {
                action()
            }
        })
    }

    log(message) {
        this.storage.add(message)
        this.sendMessages()
    }

    async _sendMessages() {
        let messages = this.storage.get()
        if (messages.length === 0) return
        // Fire and forget: every message is sent at most once. The backend does not
        // deduplicate, so a retry after a lost response would count the metric twice.
        // A failed send (offline, ad blockers, page unload) is dropped on purpose.
        this.client.send(messages).catch(() => {})
        this.storage.sent(messages)
    }
}

export default new Metric(storage,client)